import { CannotRecordReason, VideoRecorder } from "@flow/frontend/common/VideoRecorder";
import { Text } from "@flow/lib/i18n";
import { TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";

export function SendAMessageVideoForm(props: {
  presubmitVideoText: string;
  videoIntroductionTemplate: string;
  videoIntroduction: string;
  onVideoIntroductionChange: (_: string) => void;
  video: Blob | undefined;
  onGotVideo: (_: Blob | undefined) => void;
}) {
  const [cannotRecordReason, setCannotRecordReason] = React.useState<
    undefined | "NotAllowed" | "BrowserUnsupported" | "SetupFailed"
  >(undefined);

  return (
    <>
      {cannotRecordReason && <CannotRecordReason reason={cannotRecordReason} />}

      {props.video === undefined && cannotRecordReason === undefined && (
        <VideoRecorder
          onCannotRecord={setCannotRecordReason}
          nextButtonText={
            <Text id="plugin.send_a_message.im_happy_with_this_video">I&apos;m happy with this video</Text>
          }
          onGotVideo={(blob) => props.onGotVideo(blob)}
          maxDuration={60}
        />
      )}

      {props.video !== undefined && (
        <TextField
          required
          label={<Typography variant="caption"> {props.presubmitVideoText}</Typography>}
          id="message-body"
          name="message_body"
          value={props.videoIntroduction}
          onChange={({ currentTarget: { value } }) => props.onVideoIntroductionChange(value)}
          multiline
          rows={4}
          fullWidth
        />
      )}
    </>
  );
}
